import React from 'react';
import { Svg, Path } from 'react-native-svg';

export const SwapIcon = ({ size = '18px', color = '#415FFF' }) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99533 0.498047C11.273 0.498047 13.3291 1.4256 14.8183 2.91999L17.2403 0.498047V7.71236H10.0259L13.3497 4.38862C12.2315 3.2704 10.701 2.55928 8.99533 2.55928C5.57884 2.55928 2.81163 5.32648 2.81163 8.74297H0.760709C0.760709 4.18765 4.44001 0.498047 8.99533 0.498047Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.00469 17.5019C6.72703 17.5019 4.67095 16.5744 3.18171 15.08L0.759766 17.5019V10.2876H7.97407L4.65034 13.6114C5.76856 14.7296 7.29902 15.4407 9.00469 15.4407C12.4212 15.4407 15.1884 12.6735 15.1884 9.25702H17.2393C17.2393 13.8123 13.56 17.5019 9.00469 17.5019Z"
            fill={color}
        />
    </Svg>
);
